import { defineStore } from "pinia";

export type DataobjectSchema = {
	title: string;
	stacked: boolean;
	emphasized: boolean;
	tags: string[];
	type: "" | "collection" | "input" | "output" | "associated" | "storage" | "image" | "notitia";
	color: string;
};
export type CellBodySchema = {
	name: string;
};
export type CellSatelliteSchema = {
	type: "input" | "output";
};
export type EventSchema = {
	mode:
		| "interrupt"
		| "non-interrupt"
		| "catching"
		| "boundary-interrupt"
		| "boundary-non-interrupt"
		| "throwing"
		| "standard-end";
	type:
		| "mail"
		| "timer"
		| "up"
		| "rules"
		| "link"
		| "error"
		| "cancel"
		| "compensate"
		| "signal"
		| "multiple"
		| "parallel"
		| "terminate"
		| "notitia";
	color: string;
	alignment: "left" | "right" | "up" | "down";
	note: string;
};
export type GenericPillSchema = {
	text: string;
	color: string;
};
export type ViewSchema = {
	color: string;
	text: string;
};

export const useGraphlyTemplatesStore = defineStore("GraphlyTemplatesStore", () => {
	const cellBodyShape = "https://cdn.graphly.dev/@livereader/cell-body/latest";
	const cellSatelliteShape = "https://cdn.graphly.dev/@livereader/cell-satellite/latest";
	const dataobjectShape = "https://cdn.graphly.dev/@livereader/dataobject/latest";
	const eventShape = "https://cdn.graphly.dev/@livereader/event/latest";
	const genericPill = "https://cdn.graphly.dev/@livereader/generic-pill/latest";
	const viewShape = "https://cdn.graphly.dev/@livereader/workspace/latest";

	return {
		cellBodyShape,
		cellSatelliteShape,
		dataobjectShape,
		eventShape,
		genericPill,
		viewShape,
	};
});
